module.exports = __webpack_public_path__ + "img/icon_files.1327175a.svg";